import introspectionResult from "./schema.json"

// Extract possibleTypes from the introspection result for Apollo Client
// This is needed for proper fragment matching on union and interface types
type PossibleTypesMap = Record<string, string[]>

export const possibleTypes: PossibleTypesMap = {}

const schema = introspectionResult.data.__schema

schema.types.forEach((supertype) => {
  if (supertype.possibleTypes) {
    possibleTypes[supertype.name] = supertype.possibleTypes.map(
      (subtype) => subtype.name
    )
  }
})

export default possibleTypes
